import React from 'react';
import ComingSoon from '../../components/common/ComingSoon';

const icon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

const Questions = () => (
  <ComingSoon
    title="Sorular"
    description="Teknik sorularinizi sorabileceginiz, uzmanlardan yanit alabileceginiz soru-cevap platformu yakinda burada."
    icon={icon}
    activeId="feed_question"
  />
);

export default Questions;
